module.exports = "<template> <div class=tyl-divider role=separator part=root></div> </template>";